import useSelect from 'hooks/select'
import InfiniteSelect from './_private/InfiniteSelect'
import type { BaseSelectProps } from './SelectComponents'
import { BaseSelect } from './SelectComponents'

const AsyncSelect = (props: BaseSelectProps & { selectAll?: boolean; selectAllTag?: boolean }) => {
  const { mapper } = useSelect()

  return (
    <BaseSelect
      component={InfiniteSelect}
      mapper={mapper}
      {...props} /** @todo if apiPlatform, by default mapper should be iriMapper */
    />
  )
}

export default AsyncSelect
